import { PcmpCorrectionQueueTable } from '../components/PcmpCorrection/PcmpCorrectionQueueTable';

export function PcmpCorrectionQueuePage() {
  return <PcmpCorrectionQueueTable />;
}
